/* eslint-disable max-len */
/**
 * Return getUserMedia if supported, otherwise reject with an error
 *
 * Fix for `undefined is not an object (evaluating 'window.navigator.mediaDevices.getUserMedia')`
 * https://sentry.io/organizations/lee-ellam-forever/issues/2293955315/
 *
 * @param {object} constraints
 * @returns {Promise}
 */
export default function getUserMedia(constraints = { audio: true }) {
  if (
    typeof navigator === "object" &&
    typeof navigator.mediaDevices === "object" &&
    typeof navigator.mediaDevices.getUserMedia === "function"
  ) {
    return navigator.mediaDevices.getUserMedia(constraints);
  }

  return Promise.reject(new Error("getUserMedia is not supported"));
}
